module.exports = __webpack_public_path__ + "static/media/eac.6c2c4aae.svg";